import { CommonAction } from '../../../login/redux/types';
import DealTypes, { Amount, Cashflowgraph, DataRoom, Deals, TrackRecords, Webinar } from './types';

function getDeals(): CommonAction {
    return {
        type: DealTypes.GET_DEALS_REQ,
        payload: undefined,
    };
}

function setDeals(deals: { deals: Deals[]; pastDeals: Deals[]; ongoingDeals: Deals[] }): CommonAction {
    return {
        type: DealTypes.SET_DEALS,
        payload: deals,
    };
}

function getDealDetailReq(uuid: string, history: any): CommonAction {
    return {
        type: DealTypes.GET_DEAL_DETAIL_REQ,
        payload: { uuid, history },
    };
}

function setDealDetail(deal: Deals | undefined): CommonAction {
    return {
        type: DealTypes.SET_DEAL_DETAIL,
        payload: deal,
    };
}

function getDealDataRoomReq(dealUUID: string): CommonAction {
    return {
        type: DealTypes.GET_DEAL_DATA_ROOM_REQ,
        payload: dealUUID,
    };
}

function setDealDataRoom(dataRoom: DataRoom[]): CommonAction {
    return {
        type: DealTypes.SET_DEAL_DATA_ROOM,
        payload: dataRoom,
    };
}

function getDealWebinarReq(dealUUID: string): CommonAction {
    return {
        type: DealTypes.GET_DEAL_WEBINAR_REQ,
        payload: dealUUID,
    };
}

function setDealWebinars(webinars: Webinar[]): CommonAction {
    return {
        type: DealTypes.SET_DEAL_WEBINAR,
        payload: webinars,
    };
}

function setDisclosure(disclosure: boolean): CommonAction {
    return {
        type: DealTypes.SET_DISCLOSURE,
        payload: disclosure,
    };
}

function fetchTrackRecords(dealUUID: string): CommonAction {
    return {
        type: DealTypes.FETCH_TRACK_RECORDS,
        payload: dealUUID,
    };
}

function setTrackRecords(trackRecords?: TrackRecords): CommonAction {
    return {
        type: DealTypes.SET_TRACK_RECORDS,
        payload: trackRecords,
    };
}

function fetchCashflowSimulator(payload: { amount: Amount; dealUUID: string }): CommonAction {
    return {
        type: DealTypes.FETCH_CASHFLOW_SIMULATOR,
        payload: payload,
    };
}

function setCashflowSimulator(list: Cashflowgraph[]): CommonAction {
    return {
        type: DealTypes.SET_CASHFLOW_SIMULATOR,
        payload: list,
    };
}


function getTermSheetReq(dealUUID: string): CommonAction {
    return {
        type: DealTypes.GET_TERM_SHEET_DATA_REQ,
        payload: dealUUID,
    };
}
function setTermSheetData(docSendId?: string): CommonAction {
    return {
        type: DealTypes.SET_TERM_SHEET_DATA,
        payload: docSendId,
    };
}

function fetchTeaserDoc(dealUUID: string): CommonAction {
    return {
        type: DealTypes.FETCH_TEASER_DOC,
        payload: dealUUID,
    };
}

function setTeaserDoc(doc: DataRoom[]): CommonAction {
    return {
        type: DealTypes.SET_TEASER_DOC,
        payload: doc,
    };
}

const DealActions = {
    getDeals,
    setDeals,
    getDealDetailReq,
    setDealDetail,
    getDealDataRoomReq,
    setDealDataRoom,
    getDealWebinarReq,
    setDealWebinars,
    setDisclosure,
    fetchTrackRecords,
    setTrackRecords,
    fetchCashflowSimulator,
    setCashflowSimulator,
    getTermSheetReq,
    setTermSheetData,
    fetchTeaserDoc,
    setTeaserDoc,
};

export default DealActions;
